<template>
  <b-container class="mt-3">
    <b-card class="data-card">
      <template v-slot:header>
        <h4 class="mb-0 pt-1 flex-shrink-0 mr-auto">
          {{ cardName }}
        </h4>
        <b-form-checkbox
          v-if="!disableHiddenFilter"
          v-model="showHidden"
          size="md"
          class="flex-shrink-0 pt-2"
          @change="onHiddenChange"
        >
          Show Hidden
        </b-form-checkbox>
        <b-form-input
          v-model="search"
          v-debounce="searchDebounce"
          placeholder="Search "
          class="search-field"
        />
        <b-button
          v-for="(headerButton,index) in headerButtons"
          :key="index"
          :variant="headerButton.variant"
          class="flex-shrink-0"
          @click="headerButton.callback()"
        >
          {{ headerButton.title }}
        </b-button>
      </template>
      <b-table
        striped
        responsive="md"
        :items="items"
        :fields="fields"
        :sort-by="orderBy"
        :sort-desc="orderDesc"
        no-local-sorting
        @sort-changed="onSortChange"
      >
        <template 
          v-for="customCell in customCells"
          v-slot:[`cell(${customCell.key})`]="data"
        >
          {{ customCell.callback(data.item) }}
        </template>
        <template v-slot:cell(actions)="row">
          <a
            v-for="(action,index) in actions"
            :key="index"
            class="action-item"
            href="#"
            :class="action.classCallback? action.classCallback(row.item) : action.class"
            @click="action.callback(row.item)"
          >
            <i :class="action.icon" />
          </a>
        </template>
      </b-table>
      <div class="d-flex justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="itemsCount"
          :per-page="perPage"
          aria-controls="events-table"
          @change="onPageChange"
        />
      </div>
    </b-card>
  </b-container>
</template>

<script>
  export default {
    name: "BeTable",
    props: ['cardName', 'disableHiddenFilter', 'baseUrl', 'fields', 'headerButtons', 'actions', 'refresh','customCells', 'orderBy'],
    data() {
      return {
        items: [],
        // orderBy: '',
        orderDesc: false,
        search: '',
        showHidden: false,
        itemsCount: 0,
        perPage: 20,
        currentPage: 1,
      }
    },
    watch: {
      refresh: async function (val) {
        if (val) {
          await this.getData();
        }
      }
    },
    async created() {
      await this.getData();
    },
    methods: {
      async getData() {
        let response = await this.$http.get(`${this.baseUrl}?orderBy=${this.orderBy}&search=${this.search}&orderByDirection=${this.orderDesc ? 'desc' : 'asc'}&searches[hidden]=${this.showHidden}&limit=${this.perPage}&page=${this.currentPage}`);
        this.items = response.data.items;
        this.itemsCount = response.data.totalCount;
        this.$emit('refreshed');
      },
      async onPageChange(page) {
        this.currentPage = page;
        await this.getData();
      },
      async searchDebounce() {
        await this.getData();
      },
      async onHiddenChange(event) {
        this.currentPage = 1;
        this.showHidden = event;
        await this.getData();
      },
      async onSortChange(event) {
        this.orderBy = event.sortBy;
        this.orderDesc = event.sortDesc;
        await this.getData();
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/variables.scss";
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";

  .data-card .card-body {
    padding: 0px;
  }

  .data-card .card-header {
    padding-left: 12px;
    padding-right: 12px;

    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @include media-breakpoint-down(sm) {
      padding-left: 0px;
    }
  }

  .data-card .card-header > * {
    &:not(:first-child) {
      margin-left: 12px;
    }

    @include media-breakpoint-down(sm) {
      margin-bottom: 6px;
    }
  }

  h4 {
    @include media-breakpoint-down(sm) {
      flex-basis: 100%;
      margin-left: 12px;
    }
  }

  .search-field {
    flex-basis: 25%;

    @include media-breakpoint-down(sm) {
      flex-basis: auto;
      flex-grow: 1;
      width: auto;
      order: 1;
    }
  }

  /deep/ .tb-col-narrow {
    width: 75px !important;
  }

  .table-edit {
    margin-left: 3px;
    margin-right: 3px;

    i {
      color: $info;
    }
  }

  .table-delete {
    margin-left: 3px;
    margin-right: 3px;

    i {
      color: $danger;
    }
  }

  .table-viber {
    margin-left: 3px;
    margin-right: 3px;
  }
</style>